import AbstractService from '@/api/services/AbstractService';

class AdminExpedientService extends AbstractService {
  public async create(expedient: any) {
    return this.request('post', this.buildPath('admin/expedient'), [], expedient);
  }
}

export default new AdminExpedientService();
